import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VSelect,{attrs:{"items":_vm.groupRoleList,"item-text":"name","item-value":"groupRoleId","menu-props":{ maxHeight: '400' },"label":_vm.label},model:{value:(_vm.selectedGroupRoleId),callback:function ($$v) {_vm.selectedGroupRoleId=$$v},expression:"selectedGroupRoleId"}})
}
var staticRenderFns = []

export { render, staticRenderFns }